namespace Nobox.Nobox {
    export interface Lead {
        Id?: number;
        ExtId?: string;
        IdExt?: string;
        Tel?: string;
        Name?: string;
        Category?: string;
        Photo?: string;
        Address?: string;
        Country?: string;
        State?: string;
        City?: string;
        LocatedIn?: string;
        Phone?: string;
        Website?: string;
        Rating?: string;
        Reviews?: string;
        Postal?: string;
        Latitude?: string;
        Longitude?: string;
        OpenHours?: string;
        Location?: string;
        Email?: string;
        Phone2?: string;
        ExtSites?: string;
        Tags?: string;
        Url?: string;
        Tool?: string;
        Search?: string;
        Username?: string;
        AccessHash?: string;
        ListId?: string;
        List?: string;
        In?: string;
        Up?: string;
        Unik?: string;
        Progress?: number;
        Manager?: string;
        VatNumber?: string;
        Notes?: string;
        LinkId?: number;
    }
}
